<template>
    <div class="float-left">
        <i
            class="fa fa-pencil-square-o fa-lg icon-button"
            title="Documentos da Despesa"
            @click.stop="abrirModal()"
        ></i>

        <b-modal
            id="modalPrestacaoFinal"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
        >
            <div slot="modal-title">
                Documentos da Despesa
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="idPrestacaoContasMensal">Prestação Mensal</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasMensal"
                                    type="text"
                                    v-model="prestacaoFinal.idPrestacaoContasMensal"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="idPrestacaoContasFinal">Despesa</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasFinal"
                                    type="text"
                                    v-model="prestacaoFinal.idPrestacaoContasFinal"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="dtEmissao">Data Emissão</label>
                            <b-input-group>
                                <b-form-input
                                    id="dtEmissao"
                                    type="text"
                                    v-model="dtEmissao"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuTotalGasto">Valor</label>
                            <b-input-group>
                                <money
                                    id="nuTotalGasto"
                                    v-model="prestacaoFinal.nuValor"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                                <b-form-invalid-feedback>Total Despesas é obrigatória</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5">
                                    Documentos
                                </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    idTabela="tblPrestacaoFinal"
                                    :itens="DocumentoConvenio"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false"
                                >
                                    <template slot="botoes">
                                        <b-button-group class="float-right" v-if="$temAcesso('GESCON-FORN-CONV-10')">
                                            <cad-documento
                                                class="mr-2"
                                                :idPrestacaoFinal="prestacaoFinal.idPrestacaoContasFinal"
                                                :convenio="convenio"
                                                @atualizarLista="listarDocumentos()"
                                                v-if="prestacaoFinal.codSituacao == 0"
                                            >
                                            </cad-documento>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span class="text-danger float-left mr-1" v-if="$temAcesso('GESCON-FORN-CONV-11')">
                                            <i
                                                class="fa fa-trash fa-lg icon-button"
                                                title="Excluir Documento"
                                                @click.stop="excluir(data.id_Documento)"
                                                v-if="prestacaoFinal.codSituacao == 0 && convenio.idSituacaoConvenio != 9"
                                            ></i>
                                        </span>
                                        <span class="text-success float-left mr-1">
                                            <i
                                                class="fa fa-download fa-lg icon-button"
                                                title="Download"
                                                @click.stop="download(data)"
                                            ></i>
                                        </span>
                                        <span class="text-success float-left mr-1">
                                            <Visualizar
                                                :parentData="data"
                                            >
                                            </Visualizar>
                                        </span>
                                    </template>
                                    <template slot="nuValor" slot-scope="data">
                                        <p class="text-right m-0">
                                            {{ data.nuValor | currency }}
                                        </p>
                                    </template>
                                    <template slot="dtEmissao" slot-scope="data">
                                        <p class="text-left m-0">
                                            {{ data.dtEmissao ? $moment(data.dtEmissao).format('DD/MM/YYYY') : '' }}
                                        </p>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>

        </b-modal>
    </div>
</template>


<script>
    import ConveniosServicos from '../ConvenioServicos'
    import CadDocumento from '../cadastros/CadDocumentos.vue'
    import Visualizar from './VisualizarDocumento.vue'

    export default {
        components: {
            CadDocumento,
            Visualizar
        },

        props: {
            convenio: {
                type: Object,
                default: () => ({})
            },
            prestacaoFinal: {
                type: Object,
                default: () => ({})
            },
        },

        data() {
            return {
                mostrarModal: false,
                erros: [],
                itensPorPagina: 5,
                DocumentoConvenio: [],
                dtEmissao: null,
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                campos: [
                    {
                        key: 'id_Documento',
                        label: 'id',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'tipoDocumento.vcDescricaoTipoDocumento',
                        label: 'Tipo Documento',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'vcDescricaoDocumento',
                        label: 'Descrição',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'vcNomeArquivo',
                        label: 'Arquivo',
                        filterable: true,
                        sortable: true
                    },
                    {
                        key: 'acoes',
                        label: ''
                    }
                ]
            }
        },

        methods: {
            abrirModal() {
                this.mostrarModal = true;
                this.listarDocumentos()
                this.dtEmissao = this.$moment(this.prestacaoFinal.dtEmissao, 'YYYY-MM-DD').format('DD/MM/YYYY');
            },

            fecharModal() {
                this.mostrarModal = false;
            },

            listarDocumentos(){
                if (this.prestacaoFinal.idPrestacaoContasFinal > 0){
                    this.$store.dispatch('addRequest')
                    ConveniosServicos.ListarDocumentosPrestacaoFinal(this.prestacaoFinal.idPrestacaoContasFinal).then(
                        response => {
                            if (response) {
                                if (response.success) {
                                    this.DocumentoConvenio = response.data
                                    //console.log(this.DocumentoConvenio)

                                } else {
                                    this.erros = response.errors
                                }
                            }
                            this.$store.dispatch('removeRequest')
                        }
                    )
                }
            },

            excluir(id){
                this.$store.dispatch('addRequest')
                    ConveniosServicos.ExcluirDocumentoConvenio(id).then(
                        response => {
                            if (response) {
                                this.listarDocumentos()
                            }
                            this.$store.dispatch('removeRequest')
                        }
                    )
            },

            download(doc){
                this.$store.dispatch('addRequest')
                ConveniosServicos.downloadDocumento(doc.id_Documento)
                .then(response => {
                    if (response) {
                        if (response.type === 'application/json') {
                            this.$toast.error(
                                'Erro no Download!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        } else {
                            console.log(response)
                            this.$download(
                                response,
                                doc.vcNomeArquivo
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        }
    }
</script>
